import { createStore, persist, PersistConfig } from "easy-peasy";
import storeModel from "src/store/store";
import { StoreModel } from "src/types/store/StoreModel";

// We should move this to src/store/store once we've cleaned up the model there
const store = createStore<StoreModel>(persist(storeModel, { allow: ["cart"] }));
export default store;
